module.exports = new __parcel__URL__("Events.4f81d6ed.webp").toString();